export default function createRedirectReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'POST_REDIRECT_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'POST_REDIRECT_ERROR':
            return {...state, ...{error: action.error}};

        case 'POST_REDIRECT_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}